import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { columns } from "./columns";
import { loadLocations, updateLocation } from "../../store/actions/locationAction";
import ListAltimmo from "../../components/ListAltimmo";

class Altimmo extends Component {
  componentDidMount() {
    this.props.loadLocations();
  }

  render() {
    const { locations, typesEmails } = this.props;

    return (
      <Spin spinning={!locations} size="large" tip="Chargement en cours...">
        <ListAltimmo
          locations={
            locations && locations.sort((a, b) => a.location_id - b.location_id)
          }
          typesEmails={typesEmails.sort((a, b) => a.id - b.id)}
          tableOption={columns}
          updateLocation={this.props.updateLocation}
          addPanesRequete={this.props.addPanesRequete}
        ></ListAltimmo>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: () => dispatch(loadLocations()),
    updateLocation: (jsonData, id) => dispatch(updateLocation(jsonData, id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locations: state.locations.data,
    typesEmails: state.typesEmails.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Altimmo);
